import type { SpendingCustomerListResponse } from '@/modules/tracking/new-subscriber-analysis/types.ts'
import { apiClient } from '@/utils/axios.ts'
import { dateToString } from '@/utils/helpers.ts'

export const getSpendingListCustomer = async (
  creatorId: number,
  high: boolean,
  from: Date,
  to: Date,
  size: number,
  page: number,
  spendLimit: number,
  signal: AbortSignal | undefined,
): Promise<SpendingCustomerListResponse> => {
  const params = {
    from: dateToString(from),
    to: dateToString(to),
    page,
    size,
    spendLimit,
  }
  const response = await apiClient.get(
    `/new-subscriber/statistic/${creatorId}/spend-list/${high ? 'high-spend-list' : 'low-spend-list'}`,
    {
      params,
      signal,
    },
  )

  return response.data
}
